import { render, staticRenderFns } from "./BarGroup.vue?vue&type=template&id=975356f8&scoped=true&"
import script from "./BarGroup.vue?vue&type=script&lang=js&"
export * from "./BarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975356f8",
  null
  
)

export default component.exports